var common = {
  black: '#000',
  white: '#fff'
};
export default common;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/colors/common.js
// module id = 1171
// module chunks = 1